import React from "react";
import certificatesData from "../data/certificates";

const Certificates = () => {
  return (
    <div>
      <div className="p-5 sm:px-20 bg-slate-100 dark:bg-slate-900 dark:text-white m-5 rounded-3xl">
        <h1 className="text-center underline font-serif text-3xl font-bold text-purple-700">
          Certificates
        </h1>
        {certificatesData.map((c) => (
          <div className="pt-6" key={c.title}>
            <div className="text-lg">
              <div className="justify-center items-center flex bg-slate-300 dark:bg-slate-600 rounded-xl px-3 py-2">
                <div className="pr-2">
                  <i className="fa-solid fa-arrows-to-dot"></i>
                </div>
                <div className="font-bold text-xl">{c.title}</div>
                <div className="pl-2">
                  <i className="fa-solid fa-arrows-to-dot"></i>
                </div>
              </div>
              <div className="">
                <div className="my-2 sm:pl-4 space-x-4">
                  <ul className="space-y-2">
                    <div className="sm:flex sm:space-x-4">
                      <li>
                        <i className="fa-solid fa-circle mr-2 text-xs"></i>
                        <span className="font-semibold">Subject:</span>
                      </li>
                      <li>{c.subject}</li>
                    </div>
                    <div className="sm:flex sm:space-x-4">
                      <li>
                        <i className="fa-solid fa-circle mr-2 text-xs"></i>
                        <span className="font-semibold">Link:</span>
                      </li>
                      <li>
                        <label title="Click here to verify the certificate">
                          <a
                            className="text-blue-600 underline font-semibold hover:text-primary-600 dark:hover:text-primary-400 break-words"
                            href={c.link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {c.link}
                          </a>
                        </label>
                      </li>
                    </div>
                    {c.id && (
                      <div className="sm:flex sm:space-x-4">
                        <li>
                          <i className="fa-solid fa-circle mr-2 text-xs"></i>
                          <span className="font-semibold">Certificate id:</span>
                        </li>
                        <li>{c.id}</li>
                      </div>
                    )}
                    {c.username && (
                      <div className="sm:flex sm:space-x-4">
                        <li>
                          <i className="fa-solid fa-circle mr-2 text-xs"></i>
                          <span className="font-semibold">Username:</span>
                        </li>
                        <li>{c.username}</li>
                      </div>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certificates;
